import { TextArea } from "@blueprintjs/core";
import { IWidgetProps } from "decorator-form";
import React from "react";

export function TextAreaWidget(props: IWidgetProps<string>) {

	return (
		<TextArea
			fill={true}
			disabled={props.disabled}
			required={props.required}
			onChange={(e) => props.onChange(e.target.value)}
			style={{minWidth: '100%', maxWidth: '100%', resize: 'vertical'}}
			value={props.value}
		/>
	);
}



// WEBPACK FOOTER //
// ./src/common/form/widgets/TextAreaWidget.tsx